import {create} from "zustand";

const useStore = create((set) => ({
    ScreenWidthForMobile:"600px",
    Languages:['en','de'],
    Language:0,
    PagesData:{
        "Rundgang": {
            "de": "Rundgang",
            "en": "Rundgang",
            "Rights": {
                "read": true,
                "write": true
            },
            "Subpages": []
        },
        "Statistic": {
            "de": "Statistik",
            "en": "Statistic",
            "Rights": {
                "read": true,
                "write": true
            },
            "Subpages": []
        },
        "Photo": {
            "de": "Foto",
            "en": "Photo",
            "Rights": {
                "read": true,
                "write": true
            },
            "Subpages": []
        },
        "ToDo": {
            "de": "ToDo",
            "en": "ToDo",
            "Rights": {
                "read": true,
                "write": true
            },
            "Subpages": []
        },
    },

    selectedPage:"Photo",

    setSelectedPage: (page) =>
        set((state) => ({
            selectedPage: page
        })),

    Houses:{Location1:["Q", "R", "O", "P","K", "L", "M","N", "U", "V", "S","T","W", "TG"]},
    Floors:["UG", "EG", "1.OG", "2.OG", "3.OG", "Dach"],

    CompanyData:false,

    setCompanyData: (Data) =>
        set((state) => ({
            CompanyData: Data
        })),

}));
export default useStore;